import React from 'react';
import { useHistory } from 'react-router-dom';
import { KpeLayout } from '../_shared/components/KpeLayout/KpeLayout';
import { mockActiveYear, mockPastYears } from '../_shared/mocks';
import { Typography } from '../_shared/components/Typography/Typography';
import { KpeActiveYearCard } from './components/KpeActiveYearCard/KpeActiveYearCard';
import { KpePastYearCard } from './components/KpePastYearCard/KpePastYearCard';
import styles from './KpeDashboardPage.module.scss';

export default function KpeDashboardPage() {
  const history = useHistory();

  return (
    <KpeLayout>
      <div className={styles.page}>
        <nav className={styles.breadcrumbs}>
          <span>Главная</span>
          <span className={styles.breadcrumbSep}>/</span>
          <span className={styles.breadcrumbCurrent}>КПЭ руководителей</span>
        </nav>
        <Typography variant="h1">КПЭ руководителей</Typography>

        <div className={styles.content}>
          <KpeActiveYearCard
            data={mockActiveYear}
            onPlan={() => history.push('/kpe/planning')}
          />
          <div className={styles.pastYears}>
            {mockPastYears.map((year) => (
              <KpePastYearCard
                key={year.year}
                data={year}
                onResults={() => {}}
                onPlans={() => {}}
              />
            ))}
          </div>
        </div>
      </div>
    </KpeLayout>
  );
}
